import { AddressInterfaceState, initialAddressState } from '../state/address.state';
import { AddressActions, EAddressActions } from '../actions/address.actions';

export function addressReducer(state: AddressInterfaceState = initialAddressState, action: AddressActions): AddressInterfaceState {
  switch (action.type) {
    case EAddressActions.GetAddressSuccess: {
      return { ...state, address: action.payload };
    }

    default:
      return state;
  }
};
